import React from "react";

import { useAppSelector } from "src/stores/redux/hooks";
import { selectIsEnabled } from "src/stores/redux/features/striim-ai/striim-ai.slice";
import HomepageCard from "../common/homepage_card";
import HeroAIInput from "../hero-ai-input/hero-ai-input";

const StriimAIWidget: React.FC = () => {
    const isEnabled = useAppSelector(selectIsEnabled);

    if (!isEnabled) {
        return null;
    }

    return (
        <HomepageCard
            header={<></>}
            content={<HeroAIInput />}
        />
    );
};

export default StriimAIWidget;
